<template>
  <div class="GlobalFormDemo">
    <GlobalForm
      :init-data="initData"
      :form-rules="formRules"
      :form-item-list="formItemList"
      :inline="true"
      :labelWidth="85"
      :needBtnLoading="true"
      round
      @handleConfirm="handleConfirm"
      confirmBtnName="查询"
    >
      <el-form-item
        label-width="90px"
        label="查询服务商"
        slot="contractType"
        style="margin: 0"
      >
        <el-select
          :popper-append-to-body="false"
          v-model="channel"
          placeholder="请选择服务商查询"
          clearable
          filterable
        >
          <el-option
            v-for="item in goodsStateList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label-width="70px"
        label="旧机品牌"
        slot="Oldmachinebrand"
        style="margin: 0"
      >
        <el-select
          :popper-append-to-body="false"
          v-model="brand"
          placeholder="请选择或输入品牌查询"
          clearable
          filterable
        >
          <el-option
            v-for="item in productList"
            :key="item.id"
            :label="item.name"
            :value="item.name"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </GlobalForm>
  </div>
</template>

<script>
import { formValidateMobile } from "@/utils/form-validate";
import moment from "moment";
import _api from "@/utils/request";
import {channePull,brandPull} from "../../../utils/request/changePhone";
export default {
  name: "Form",
  data() {
    return {
      brand: "",
      channel: "",
      productList: [],
      detectionList: [],
      initData: null,
      goodsStateList: [],
      formItemList: [
        { slotName: "contractType" }, //
        {
          key: "imei",
          type: "input",
          labelName: "串号",
          placeholder: "请输入串号查询",
          labelWidth: "50px",
        },
        { slotName: "Oldmachinebrand" }, //品牌
        {
          labelWidth: "80px",
          key: "entryTime",
          type: "daterange",
          labelName: "查询时间",
          placeholder: "请选择查询时间",
          valueFormat: "timestamp",
        },
      ],
      formRules: {
        mobile: [
          {
            validator: formValidateMobile,
            trigger: "blur",
          },
        ],
      },
      SeachParams: {},
    };
  },
  created() {
    this.getChannePull();
    this.getBrandPull();
    this.handleConfirm()
  },
  methods: {
    // 获取服务商列表
    getChannePull() {
      channePull().then((res) => {
        this.goodsStateList = res.data;
      });
    },
    // 获取旧机品牌列表
    getBrandPull() {
      brandPull().then((res) => {
        this.productList = res.data;
      });
    },
    //查询
    handleConfirm(data,cd) {
      console.log(data);
      let beg_time = "";
      let end_time = "";
      if (!data || !data.entryTime) {
        beg_time = "";
        end_time = "";
      } else {
        beg_time = Number(moment(data.entryTime[0]).format("x"));
        end_time = Number(moment(data.entryTime[1]).format("x"));
      }
      
      const baseRequest = {
        imei: data && data.imei ? data.imei : "",
        brand: this.brand,
        channel: this.channel,
        beg_time: beg_time,
        end_time: end_time,
        disuseLoding: () => {
          if (typeof cd === 'function') {
            cd()
          }
        },
      };
      this.SeachParams = baseRequest;
      this.$store.commit("tagsView/SEACH_PARAMS", baseRequest);
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo {
  /deep/.el-select-dropdown {
    border-radius: 20px;
  }

  .select_down {
    /deep/.el-popper {
      border-radius: 20px;
    }

    /deep/.el-select-dropdown__item.hover,
    .el-select-dropdown__item:hover {
      background-color: #e4ecfd;
      color: rgba(9, 129, 255, 1);
    }
  }

  .flex {
    display: flex;
    align-items: center;
  }

  .time-type {
    /deep/.el-input__inner {
      border: none;
    }
  }
}
</style>
